import React from 'react';
import RestrictionDetailSection from '../../../sections/AdminDashboard/SecurityFraud/RestrictionDetail';

const RestrictionDetail = () => {
  return <RestrictionDetailSection />;
};

export default RestrictionDetail;

